"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelNext = void 0;
/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};
exports.labelNext = labelNext;
//# sourceMappingURL=labelNext.js.map